// extracted by mini-css-extract-plugin
export default {"pageContainer":"Pagination_pageContainer__aHtEr","myPage":"Pagination_myPage__FMWvI"};